import { render, staticRenderFns } from "./StaffExpansionPanel.vue?vue&type=template&id=5ab6d4a4&scoped=true&"
import script from "./StaffExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./StaffExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./StaffExpansionPanel.vue?vue&type=style&index=0&id=5ab6d4a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab6d4a4",
  null
  
)

export default component.exports